<template>
  <div>

    <div class="center big-padding">
      Souhaitez-vous supprimer le secteur <strong>{{secteur.nom}}</strong> ({{ secteur.arrondissement_id | arrondissementName }}) ?
    </div>

    <div class="buttons">
      <div class="btn btn-primary" v-on:click='confirm()'>
        Supprimer
      </div>

      <div class="btn btn-default" v-on:click="$emit('close')">
        Annuler
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../../store'

export default {
  props: [
    'secteur',
  ],
  methods: {
    confirm: function () {
      this.$store.dispatch('deactivateSecteur', this.secteur)
      this.$emit('close')
    },
  },
}
</script>



// WEBPACK FOOTER //
// SecteursDelete.vue?5ff99760